export default {
  placeholder: 'Rechercher un restaurant...',
};
